/**
 * aZcentric - The framework for aZcentric.
 * @version v0.5.1-dev
 * @link http://www.azaas.com/
 * @license 
 */
(function () {
    'use strict';
    var Alert = /** @class */ (function () {
        function Alert() {
        }
        Alert.prototype.close = function (e) {
            var $this = angular.element(this);
            var $parent = $this.parent();
            if (e)
                e.preventDefault();
            $parent.removeClass('in');
            function removeElement() {
                // detach from parent, fire event then clean up data
                $parent.detach().remove();
            }
            removeElement();
        };
        Alert.VERSION = '3.3.6';
        Alert.TRANSITION_DURATION = 150;
        Alert.HIDE_DELAY = 3000;
        return Alert;
    }());
    var alertModule = angular.module('aZcentric.components.alert', []);
    alertModule.directive('alertDismissable', alert);
    alertModule.directive('alertDismissible', alert);
    alert.$inject = ['$parse', '$timeout'];
    function alert($parse, $timeout) {
        var directive = {
            link: link,
            restrict: 'C'
        };
        return directive;
        function link(scope, element, attrs) {
            var plugin = new Alert();
            var btn = element.find('button').bind('click', plugin.close);
            if (!angular.isDefined(attrs.autoClose) || attrs.autoClose == false) {
                var delay = $parse(attrs.hideDelay)(scope) || Alert.HIDE_DELAY;
                $timeout(function () { plugin.close.apply(btn); }, delay);
            }
        }
    }
    alertModule.factory('AlertService', AlertService);
    AlertService.$inject = ['$compile', '$document'];
    function AlertService($compile, $document) {
        var $body = angular.element($document[0].body);
        var container = $body.find('.alert-container');
        if (!container || !container.length) {
            container = angular.element('<div class="container alert-container"></div>');
            $body.append(container);
        }
        var service = {
            showAlert: showAlert,
            showSuccess: _showSuccess,
            showError: _showError,
            messages: _alertMessages
        };
        return service;
        /**
         * show alert message
         *
         * @param {String} message text
         * @param {String} [messageType='alert-info'] message type: 'alert-success', 'alert-danger', 'alert-info'
         * @param {Number} [delay=3000] close to delay(ms): 60000 ms => 1 min
         * @return {Void}
         */
        function showAlert(message, messageType, delay) {
            messageType = messageType || 'alert-info';
            if (angular.isDefined(delay)) {
                delay = delay ? 'hide-delay="' + delay + '"' : 'auto-close="false"';
            }
            var template = angular
                .element('<div class="alert ' + messageType + ' alert-dismissable" ' + delay + '>\
                            <button type="button" class="close" data-dismiss="alert" aria-hidden="True">&times;</button>\
                            ' + message + '\
                          </div>');
            container.append(template);
            $compile(template)({});
        }
        /**
         * show success message
         *
         * @param {String} message text
         * @param {Number} [delay=3000] close to delay(ms): 60000 ms => 1 min
         * @return {Void}
         */
        function _showSuccess(message, delay) {
            showAlert(message, 'alert-success', delay);
        }
        /**
         * show error message
         *
         * @param {String} message text
         * @param {Number} [delay=3000] close to delay(ms): 60000 ms => 1 min
         * @return {Void}
         */
        function _showError(message, delay) {
            showAlert(message, 'alert-danger', delay || 0);
        }
        /**
         * get message
         *
         * @return {Object} { Success: 'Saved. Navigating to list...', Error: 'An error occurred.' }
         */
        function _alertMessages() {
            return {
                Success: 'Saved. Navigating to list...',
                Error: 'An error occurred.'
            };
        }
    }
    alertModule.run(['$rootScope', '$window', 'AlertService', function ($rootScope, $window, AlertService) {
            /// <summary>
            /// inject alert service to scope
            /// </summary>
            /// <param name="$rootScope">The $root scope.</param>
            /// <param name="$window">The $window.</param>
            /// <param name="AlertService">The alert service.</param>
            /// <returns></returns>
            /// Create By: Ariesly
            /// 2016/1/29
            $rootScope.showAlert = AlertService.showAlert;
            $rootScope.showSuccess = AlertService.showSuccess;
            $rootScope.showError = AlertService.showError;
            $rootScope.messages = AlertService.messages;
            $window.showAlert = AlertService.showAlert;
        }]);
})();
